import { hotelService } from "@/services/hotel-service-service";
import { useQuery } from "@tanstack/react-query";

export const partnerRegionFlagKeys = {
  all: ["partnerRegionFlag"] as const,
  byHotel: (hotelId: string) =>
    [...partnerRegionFlagKeys.all, hotelId] as const,
};

export function usePartnerRegionFlag(hotelId?: string, enabled = true) {
  return useQuery({
    queryKey: partnerRegionFlagKeys.byHotel(hotelId ?? ""),
    enabled: Boolean(hotelId && enabled),
    queryFn: async () => {
      const response = await hotelService.getPartnerServices(hotelId!, 1, 50);
      const serviceWithFlagFromList = response.data.find(
        (service) => service.partner?.destination?.flagEmoji,
      );
      if (serviceWithFlagFromList?.partner?.destination?.flagEmoji) {
        return serviceWithFlagFromList.partner.destination.flagEmoji;
      }

      // Some environments return destination metadata only on details endpoint.
      for (const service of response.data.slice(0, 5)) {
        const details = await hotelService.getPartnerServiceById(
          hotelId!,
          service.id,
        );
        const flag = details.partner?.destination?.flagEmoji ?? null;
        if (flag) {
          return flag;
        }
      }

      return null;
    },
    staleTime: 5 * 60 * 1000,
  });
}
